import { ResponseSectionCombinedProps } from './types';

const usePresenter = (props: ResponseSectionCombinedProps): ResponseSectionCombinedProps => {
  return props;
};

export default usePresenter;
